/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delegated_Access_Mine_TitleInputs */

const en_delegated_access_mine_title = /** @type {(inputs: Delegated_Access_Mine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access tokens`)
};

/**
* | output |
* | --- |
* | "Access tokens" |
*
* @param {Delegated_Access_Mine_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const delegated_access_mine_title = /** @type {((inputs?: Delegated_Access_Mine_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delegated_Access_Mine_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_delegated_access_mine_title(inputs)
});